import React from 'react';

export default function ArrowDownIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <g
        id="arrow_drop_down"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g id="ic/arrow_drop_down">
          <g>
            <mask id="mask-2-down" fill="white">
              <polygon id="path-1" points="7 10 12 15 17 10"></polygon>
            </mask>
            <g id="Path" fillRule="nonzero"></g>
            <g id="c/grey/600" mask="url(#mask-2-down)" fill="#80868B">
              <rect id="Shape" x="0" y="0" width="24" height="24"></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
